import DBModal from "../../../component/global/DBModal";
import {useContext, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import FoodOrderModal from "./FoodOrderModal";
import FoodOrderStatusModal from "./FoodOrderStatusModal";
import FoodOrderLoginModal from "./FoodOrderLoginModal";
import {ReactComponent as CircleCheck} from '../../assets/icons/circle-check-solid.svg';
import {resolveBrandLogo} from "../../brandAssets";
import './style.scss'
import BackButton from "../../../component/global/BackButton";
import {GlobalStateContext} from "../../../layouts/GlobalStates";

const initialState = {
  step: 1,
  data: {},
}

function FoodModal({show, onClose, data, onDelete, onClearBasket, companyId}) {
  const [status, setStatus] = useState(initialState)
  const {t} = useTranslation()
  const {feedbackAppGlobalState} = useContext(GlobalStateContext)
  const [result] = feedbackAppGlobalState
  const item = result?.ajax?.item
  const itemName = item?.name || item?.company_name || ""
  const brandLogo = resolveBrandLogo(item?.company_logo)

  useEffect(() => {
    setStatus(initialState)
    if (!show) return undefined
    const timer = window.setTimeout(() => {
      document.querySelector(".food-modal .db-modal-content")?.scrollTo({
        top: 0,
      })
    }, 80)
    return () => window.clearTimeout(timer)
  }, [show])

  const onSuccess = (data) => {
    setStatus({
      step: 2,
      data,
    })
    onClearBasket?.()
  }

  const header = useMemo(() => {
    if (status.step === 1) return t("basket.title")
    if (status.step === 2) return t('modalTitle.label')
    if (status.step === 3) return <><CircleCheck/>{t('order.successfull')}</>
    return null
  }, [status.step, t])

  function page() {
    const user = sessionStorage.getItem('id')
    const auth = sessionStorage.getItem('auth')
    if (!user || !auth) {
      return (
        <FoodOrderLoginModal
          show={show}
          itemName={itemName}
        />
      )
    }
    if (status.step === 1) {
      return (
        <FoodOrderModal
          data={data}
          onDelete={onDelete}
          onSuccess={onSuccess}
          companyId={companyId}
        />
      )
    }
    if (status.step === 2) {
      return (
        <FoodOrderStatusModal data={status.data}/>
      )
    }
    return null
  }

  return (
    <div>
      <DBModal
        minWidth={440}
        show={show}
        onHide={onClose}
        className="food-modal"
      >
        <DBModal.Content>
          <div className='header-modal'>
            <BackButton specialClass='food-modal-back-btn' onclickFunction={onClose}/>
            <div className='food-modal-brand'>
              <div className='food-modal-logo'>
                <img src={brandLogo} alt=""/>
              </div>
              {itemName ? (
                <div className='food-modal-brand-name'>{itemName}</div>
              ) : null}
            </div>
            <div className={`food-modal-title ${status?.step === 3 ? 'success' : 'primary'}`}>
              {header}
            </div>
          </div>
          <div className='content-modal'>
            {page()}
          </div>
        </DBModal.Content>
      </DBModal>
    </div>
  );
}

export default FoodModal;
